<template>
    <div style="background: #ecf0f5">
        <Header/>
        <SideBar/>
        <v-container fluid>
            <v-row style="margin-top: -20px" dense>
                <v-col>
                    <v-breadcrumbs :items="items" light>
                        <template v-slot:divider>
                            <v-icon small>$vuetify.icons.values.mdiChevronRight</v-icon>
                        </template>
                    </v-breadcrumbs>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar
                                dark
                                color="#3c8dbc">
                            <v-icon>$vuetify.icons.values.mdiMagnify</v-icon>
                            <v-toolbar-title>Filters</v-toolbar-title>
                        </v-app-bar>
                        <v-container fluid>
                            <v-row dense>
                                <v-col cols="12" md="2" lg="2">
                                    <v-select
                                            label="Select Status"
                                            solo
                                            light
                                            chips
                                            deletable-chips
                                            :items="items1">

                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="3" lg="3">
                                    <v-menu
                                            ref="startDateMenu"
                                            v-model="startDateMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="startDate"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="startDate"
                                                    label="Start Date"
                                                    readonly
                                                    v-on="on"
                                                    solo

                                            />
                                        </template>
                                        <v-date-picker v-model="startDate" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn  color="primary" @click="startDateMenu = false">Cancel</v-btn>
                                            <v-btn  color="primary" @click="$refs.startDateMenu.save(startDate)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" md="3" lg="3">
                                    <v-menu
                                            ref="endDateMenu"
                                            v-model="endDateMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="endDate"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="endDate"
                                                    label="End Date"
                                                    readonly
                                                    solo
                                                    v-on="on"
                                            />
                                        </template>
                                        <v-date-picker v-model="endDate" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn  color="primary" @click="endDateMenu = false">Cancel</v-btn>
                                            <v-btn  color="primary" @click="$refs.endDateMenu.save(endDate)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="3" lg="3"
                                       class="d-flex justify-lg-center justify-md-center justify-center">
                                    <v-btn color="#3c8dbc" dark>Search</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar
                                dark
                                color="#3c8dbc">
                            <v-toolbar-title>List of Test Takers</v-toolbar-title>
                        </v-app-bar>
                        <v-card-title>
                            <v-row>
                                <v-col md="8">
                                </v-col>
                                <v-text-field
                                        label="Search">
                                </v-text-field>
                                <v-btn class="ma-2" color="#3c8dbc" dark>
                                    <v-icon dark>$vuetify.icons.values.mdiMagnify</v-icon>
                                </v-btn>
                            </v-row>
                        </v-card-title>
                        <v-row dense>
                            <v-col>
                                <v-data-table
                                        :headers="headers"
                                        :items="data.tableDataWrapper.rowData"
                                        :search="search"
                                        :items-per-page=10
                                        :footer-props="{
                                            'items-per-page-options': [10],
                                            'show-current-page':true
                                        }">
                                    <template v-slot:item.session="{ item }">
                                        <span v-if="item.report_available">{{item.session}}</span>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-slot:item.report_available="{ item }">
                                        <span v-if="item.report_available">
                                                <v-btn text icon href="report.pdf">
                                                       <v-icon color="green">$vuetify.icons.values.mdiFileDownloadOutline</v-icon>
                                                </v-btn>

                                        </span>
                                        <span v-else>
                                             <v-btn text icon disabled>
                                                       <v-icon>$vuetify.icons.values.mdiFileDownloadOutline</v-icon>
                                                </v-btn>
                                        </span>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
    import Chart from "../charts/DonutPieChart";
    import BarChart from "../charts/BarChart";
    import Header from "./Header";
    import SideBar from "./SideBar";
    // eslint-disable-next-line no-unused-vars
    const data = require('../data/sample');
    export default {
        name: 'Results',
        components: {SideBar, Header},
        data() {
            return {
                items: [
                    {
                        text: 'Home',
                        disabled: true,
                        href: 'breadcrumbs_dashboar'
                    },
                    {
                        text: 'Results',
                        disabled: true,
                        href: 'breadcrumbs_link_1'
                    }
                ],
                components: {
                    Chart,
                    BarChart,
                    Header,
                    SideBar
                },
                data,
                date: '',
                date2: '',
                search: '',
                menu: false,
                menu1: false,
                startDate:'',
                endDate:'',
                endDateMenu: '',
                startDateMenu: '',
                table: {
                    tableData: [],
                    totalLength: 0
                },
                items1: [
                    {text: 'Complete'},
                    {text: 'Incomplete'},
                    {text: 'Not Started'}
                ],
                pagination: {
                    ItemsPerPage: '',
                    itemsPerPageOptions: [10],
                },
                headers: [
                    {text: this.$t('msg.table_header_no'), align: 'left', sortable: false, value: 'index'},
                    {text: this.$t('msg.table_header_name'), value: 'name'},
                    {text: this.$t('msg.table_header_employeeId'), value: 'employee_id'},
                    {text: this.$t('msg.table_header_assessment_name'), value: 'assessmentName'},
                    {text: this.$t('msg.table_header_assessment_session'), value: 'session'},
                    {text: this.$t('msg.table_header_status'), value: 'status'},
                    {text: this.$t('msg.table_header_report'), value: 'report_available'}
                ]
            }
        }
    }
</script>
